import * as Toggle from "@radix-ui/react-toggle";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { Filter } from "@/api";

import { FILTER_PARAM } from "../const";

interface FilterSectionProps {
  filter: Filter;
}

export const FilterSection = ({ filter }: FilterSectionProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filterParam = `${FILTER_PARAM}_${filter.Id}`;
  const filterParams = useMemo(
    () => new URLSearchParams(searchParams),
    [searchParams],
  );

  const isFilterApplied = (option: string) => {
    const filters = searchParams.get(filterParam);
    if (filters) {
      const filterArray = filters.split("|");
      return filterArray.includes(option);
    }
    return false;
  };

  const handleToggle = (option: string) => {
    const currentFilters = filterParams.get(filterParam) ?? "";
    const filterArray = currentFilters.split("|").filter(Boolean);
    const optionIndex = filterArray.indexOf(option);

    if (optionIndex >= 0) {
      filterArray.splice(optionIndex, 1);
    } else {
      filterArray.push(option);
    }

    if (filterArray.length > 0) {
      filterParams.set(filterParam, filterArray.join("|"));
    } else {
      filterParams.delete(filterParam);
    }

    setSearchParams(filterParams);
  };

  return (
    <div className="mb-8">
      <div className="p2-bold">{filter.Filter}</div>
      <div className="flex flex-wrap">
        {filter.FilterOptions.map(({ Id, Option }) => (
          <Toggle.Root
            key={Id}
            pressed={isFilterApplied(Option)}
            className="p3-medium mr-2 mt-4 rounded-xl border border-solid border-border px-[12px] py-[4px] data-[state=on]:border-highlightPrimary data-[state=on]:bg-highlightBg data-[state=on]:text-highlightPrimary"
            onPressedChange={() => handleToggle(Option)}
          >
            {Option}
          </Toggle.Root>
        ))}
      </div>
    </div>
  );
};
